import { render, staticRenderFns } from "./ItemBoxesConnected.vue?vue&type=template&id=b920a8cc&"
import script from "./ItemBoxesConnected.vue?vue&type=script&lang=js&"
export * from "./ItemBoxesConnected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports